import {TrackingConsent} from '@datadog/browser-core';
import {datadogRum} from '@datadog/browser-rum';

const DEFAULT_INDENT = 4;

export class DatadogClient {
    constructor(config) {
        if (config) {
            const {
                applicationId,
                clientToken,
                env,
                service,
                site,
            } = config;

            datadogRum.init({
                allowedTracingUrls: [
                    (url) => url.startsWith(`${window.location.protocol}//${window.location.host}`),
                ],
                applicationId: applicationId,
                clientToken: clientToken,
                defaultPrivacyLevel: 'mask',
                env: env,
                service: service,
                sessionSampleRate: 100,
                site: site,
                trackLongTasks: true,
                trackResources: true,
                trackUserInteractions: true,
            });

            // Tags all RUM data from this app with the product, used for Datadog usage attribution / cost analysis
            datadogRum.setGlobalContextProperty('product', 'ph-platform');

            datadogRum.startSessionReplayRecording();

            // Store the context so we can tell if Datadog has been correctly initialised
            this.context = datadogRum.getInternalContext();
        }
    }

    static load(config) {
        return new DatadogClient(config);
    }

    // An example of how this class can be extended to provide extra functionality. In this case, setting tracking
    // consent from something like a cookie banner
    setTrackingConsent(consented) {
        datadogRum.setTrackingConsent(
            consented
                ? TrackingConsent.GRANTED
                : TrackingConsent.NOT_GRANTED,
        );
    }

    toString() {
        return JSON.stringify(this.context ?? {}, null, DEFAULT_INDENT);
    }
}
